import PageWrapper from "./PageWrapper";
import styled from "styled-components";
import { Suspense, useEffect } from "react";

import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { BiShapeTriangle } from "react-icons/bi";
import { RiEyeFill, RiEyeCloseFill } from "react-icons/ri";
import { AiFillHome } from "react-icons/ai";

import { DoubleSide } from "three";
import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { useGLTF, Environment, OrbitControls } from "@react-three/drei";

import { Canvas, useFrame } from "@react-three/fiber";
import { useRef, useState } from "react";

// const path = "/model.gltf";
// useGLTF.preload(path);

const Model = (props) => {
  // This reference will give us direct access to the mesh

  const { scene } = useLoader(GLTFLoader, props.path);
  // double sided rendering
  if (props.side === true) scene.children[0].material.side = 1;
  useFrame(() => (props.state.current.rotation.y += 0.0007 * Math.PI));

  useEffect(() => {
    if (props.state && props.state.current) {
      if (props.state.current.position.y === 0)
        props.state.current.position.y -= 4 * props.scale;
      if (props.left === true && props.state.current.position.x === 0)
        props.state.current.position.x -= 40 * props.scale;
      if (props.right === true && props.state.current.position.x === 0)
        props.state.current.position.x += 40 * props.scale;
    }
  }, []);

  useEffect(() => {
    if (props.state && props.state.current) {
      props.state.current.visible = props.visible;
    }
  }, [props.visible]);

  return (
    <mesh>
      <primitive ref={props.state} object={scene} />
    </mesh>
  );
};

const getScale = (index) => {
  switch (index) {
    case 1:
      return [1, 50];
    case 4:
      return [0.23, 15];
    case 10:
      return [0.2, 15];
    case 12:
      return [1.3, 130];
    case 48:
      return [0.1, 5];
    case 31:
      return [0.7, 50];
    case 22:
      return [0.26, 17];
    case 50:
      return [0.3, 25];
    case 21:
      return [0.3, 20];
    case 25:
      return [1, 66];
    default:
      return [1, 50];
  }
};

const DemoPage = (props) => {
  console.log(props.index);

  const [org, setOrg] = useState(true);
  const [ours, setOurs] = useState(true);
  const [base, setBase] = useState(true);
  const [scale, position] = getScale(props.index);

  const orgRef = useRef();
  const oursRef = useRef();
  const baseRef = useRef();

  const path_org = `/models/${props.index}/${props.index}_gt.gltf`;
  const path_base = `/models/${props.index}/${props.index}_mesh.gltf`;
  const path_ours = `/models/${props.index}/${props.index}_merged.gltf`;

  return (
    <PageWrapper>
      <VisiblePannel
        org={org}
        setOrg={setOrg}
        ours={ours}
        setOurs={setOurs}
        base={base}
        setBase={setBase}
      />
      <DemoHeader onClick={props.onClickMain}>
        <AiFillHome
          color="white"
          size="14px"
          style={{ paddingBottom: "3px" }}
        />
        <PannelText>MultiDreamer</PannelText>
      </DemoHeader>
      <Canvas
        camera={{
          fov: 55,
          near: 0.1,
          far: 1000,
          position: [0, position, position],
        }}
      >
        <Suspense fallback={null}>
          <Environment preset="dawn" />
          {
            <Model
              path={path_org}
              state={orgRef}
              visible={org}
              left={true}
              scale={scale}
            />
          }
          {
            <Model
              path={path_ours}
              side={true}
              state={oursRef}
              visible={ours}
              scale={scale}
            />
          }
          {
            <Model
              path={path_base}
              side={true}
              state={baseRef}
              visible={base}
              right={true}
              scale={scale}
            />
          }
        </Suspense>
        <OrbitControls />
      </Canvas>
    </PageWrapper>
  );
};
export default DemoPage;

const DemoHeader = styled.div`
  width: fit-content;
  height: fit-content;
  position: absolute;
  top: 18px;
  left: 18px;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #444444;

  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 18px;
  color: "#ffffff";

  cursor: pointer;
  z-index: 100;

  width: 120px;
  height: 27px;

  background-color: #1c1c1c;
  box-sizing: border-box;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    opacity: 50%;
  }
  transition: all 0.3s;
`;

const VisiblePannel = (props) => {
  const [pannel, setPannel] = useState(false);

  return (
    <PannelWrapper>
      <PannelHeader onClick={() => setPannel((prev) => !prev)}>
        <PannelText>Display</PannelText>

        {pannel ? (
          <FaChevronUp color="white" size="15px" />
        ) : (
          <FaChevronDown color="white" size="15px" />
        )}
      </PannelHeader>
      {pannel && (
        <>
          <PannelEl bright={true} onClick={() => props.setOrg((prev) => !prev)}>
            <BiShapeTriangle color={props.org ? "white" : "gray"} size="18px" />
            <PannelText>ground_truth</PannelText>
            {props.org ? (
              <RiEyeFill color="white" />
            ) : (
              <RiEyeCloseFill color="gray" />
            )}
          </PannelEl>
          <PannelEl
            bright={false}
            onClick={() => props.setOurs((prev) => !prev)}
          >
            <BiShapeTriangle
              color={props.ours ? "white" : "gray"}
              size="18px"
            />
            <PannelText>ours</PannelText>
            {props.ours ? (
              <RiEyeFill color="white" />
            ) : (
              <RiEyeCloseFill color="gray" />
            )}
          </PannelEl>
          <PannelEl
            bright={true}
            onClick={() => props.setBase((prev) => !prev)}
          >
            <BiShapeTriangle
              color={props.base ? "white" : "gray"}
              size="18px"
            />
            <PannelText>baseline</PannelText>
            {props.base ? (
              <RiEyeFill color="white" />
            ) : (
              <RiEyeCloseFill color="gray" />
            )}
          </PannelEl>
        </>
      )}
    </PannelWrapper>
  );
};

const PannelWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  position: absolute;
  top: 18px;
  right: 18px;
  border-radius: 5px;
  overflow: hidden;
  border: 1px solid #444444;

  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 100;
`;

const PannelHeader = styled.div`
  width: 218px;
  height: 27px;

  background-color: #1c1c1c;
  box-sizing: border-box;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  cursor: pointer;
`;

const PannelEl = styled.div`
  width: 218px;
  height: 28px;

  background-color: ${(props) => (props.bright ? "#333333" : "#282828")};
  box-sizing: border-box;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  cursor: pointer;
`;

const PannelText = styled.div`
  color: white;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 0.5;
`;
